// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://mcdfkrkgkwrddtwetfww.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1jZGZrcmtna3dyZGR0d2V0Znd3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY5MDcwOTYsImV4cCI6MjA2MjQ4MzA5Nn0.EmOgarcvLVANHl5ryhvyBdjyK2wOtZLoJbTRhcaYqBU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
);
